import mutations from './patientEvidenceHistory.mutations'
import actions from './patientEvidenceHistory.actions'
import getters from './patientEvidenceHistory.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
